import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Box, MenuItem, TextField } from '@mui/material'

import { ApplicationState } from '@/state/root.models'
import { ADMIN_VIEW } from '@/constants/brand'
import { Brands } from '@/state/user/models'

import { PersonalizationEngineModels } from '@/state/personalization-engine'

type Props = {
  filters: PersonalizationEngineModels.PersonalizationEngineFiltersType
  handleChangeSearch: (field: string, value: string, debounce?: boolean) => void
}

export const BrandFilterComponent = ({
  filters,
  handleChangeSearch,
}: Props) => {
  const { t } = useTranslation()

  const { loggedUser } = useSelector(({ auth }: ApplicationState) => auth)

  const brandOptions = loggedUser.brands.filter(
    (brand) => brand.siteId !== ADMIN_VIEW,
  )

  return (
    <TextField
      fullWidth
      name="brand"
      margin="dense"
      variant="outlined"
      type="text"
      id="brand"
      label={t('reports.byBrand')}
      onChange={(e: React.ChangeEvent<{ value: string }>) => {
        handleChangeSearch('brandId', e.target.value)
      }}
      value={filters.brandId || ''}
      select
      sx={{ '& .MuiInputBase-input': { paddingBottom: '15px' } }}
    >
      <MenuItem value="-1">
        <Box fontStyle="italic">{t('all')}</Box>
      </MenuItem>
      {brandOptions.map((brand: Brands) => {
        return (
          <MenuItem key={brand.siteId} value={brand.siteId}>
            {brand.name}
          </MenuItem>
        )
      })}
    </TextField>
  )
}
